<template>
  <div class="w-full flex justify-center relative">
    <div v-if="isLoading" class="absolute w-full top-0 left-0 h-full"></div>
    <div class="main-container py-4">
      <zt-button color="dark-400" icon="angle-left" text class="go-back" @click="goBack" data-vs-button="go_back">
        {{ $t('message.customEmails.go_back_btn') }}
      </zt-button>
      <div class="heading pb-6 flex items-center">
        <h2 class="font-normal text-zt-primary-200">
          {{ $t('message.customEmails.title') }} > {{$route.params.idName}}
        </h2>
      </div>

      <libraryModal :value="imageLibraryModal" :editingSection="editingSection" :defaultSections="defaultSections" @close-library-modal="closeLibraryModal" @save-image="(imageUrl) => {saveImage(imageUrl)}"  />

      <div class="container">
        <h1>  {{ $t('message.customEmails.descriptionHeader') }}</h1>
        <p>
            {{ $t('message.customEmails.description') }}
        </p>
        <table class="border-solid border-2 customEmail table" aria-describedby="">
          <th class="hidden"></th>
          <tr v-for="section in sections" :key="section.name">
            <td :style="section.td_style" class="border-0 section d-flex relative">
              <div v-if="section.type == 'img'" :style="section.style">
                <img :src="section.value" :alt="section.name" class="sichern-logo" />
              </div>
              <div
                v-if="section.type == 'txt'"
                :style="section.style"
                style="white-space: pre-line; word-break: break-word; "
                v-html="$sanitize(section.value)"></div>
              <div v-if="section.type == 'btn'" :style="section.style">
                <a href="#!" :style="buttonStyles(section)">
                  <span style="display: block; min-width: 139px">{{ section.value.text }}</span>
                </a>
              </div>
              <zt-button
                v-if="section.unlocked"
                class="d-none toggleDisplay float-right"
                icon="pen"
                data-vs-button="open_modal"
                @click="openModal(section)">
                {{ $t('message.customEmails.edit') }}
              </zt-button>
              
            <div class="d-none toggleDisplay helpIcon toolpit " v-if="section.hint">
              <zt-icon
                class="text-3xl ml-px  helpIcon"
                name="info-circle-alt"
              >
              </zt-icon>
              <div class="tooltiptext">{{section.hint}}</div>
            </div>
            </td>
          </tr>
        </table>
        <div class="flex">
          <zt-switch v-model="restoreDefault" @change="restoreDefaultSections(restoreDefault)" ref="switchDefault" data-vs-switch="restore_default"/>
          <p>{{ $t('message.customEmails.restoreDefault') }}</p>
        </div>
      </div>
      <div class="footer d-flex justify-end">
        <div class="justify-end">
          <zt-button color="disabled" style="color: #707070 !important" data-vs-button="cancel_modal" @click="cancelarEditEmail">Cancelar</zt-button>
          <zt-button data-vs-button="save_modal" @click="confirmarEditEmail">{{ $t('message.customEmails.save') }}</zt-button>
        </div>
      </div>
    </div>
    <zt-modal :active="editModal" class="rounded" max-width="43rem" @close="editModal = false">
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <h4>{{ $t('message.customEmails.edit') }}</h4>
        </div>
      </template>
      <div class="w-full pt-6 flex">
        <div class="w-11/12 mx-auto flex py-4 justify-center">
          <div v-if="editingSection.type == 'img'">{{ $t('message.customEmails.imgEdit') }}</div>
          <div v-if="editingSection.type == 'txt'">
            <textarea v-model="editingSection.value" rows="8" cols="50" ref="textarea" class="border-1" data-vs-textarea="edit_section" />
            <div>
             {{ $t('message.customEmails.imgDescription') }}
              <div class="d-flex flex-wrap">
                <span v-for="(variable, index) in vars" @click="addVariable(variable)" :key="index">
                  <zt-chip square class="infoChip capitalize">{{ variable }}</zt-chip>
                </span>
              </div>
            </div>
          </div>
          <div v-if="editingSection.type == 'btn'">
            <p v-if="validations.length">
    
              <ul>
                <li v-for="(error,index) in validations" :key="index" class="text-red-500"> {{ error }}</li>
              </ul>
            </p>
            <textarea v-model="editingSection.value.text" rows="5" cols="50" ref="textarea" placeholder="Texto del boton" data-vs-textarea="btn_text"/>
            <div class="flex mt-4">
              <div class="color-pick">
                <input
                  type="color"
                  v-model="editingSection.value.bgcolor"
                  @change="updateInputTextValue('colorBgInput', editingSection.value.bgcolor)"
                  data-vs-input="update_input" 
                  required />
                >
              </div>
              <zt-input
                class="ml-4"
                label="Color de fondo"
                v-model="editingSection.value.bgcolor"
                ref="colorBgInput"
                data-vs-input="edit_section" 
                outlined />
            </div>
            <div class="flex mt-4">
              <div class="color-pick">
                <input
                  type="color"
                  data-vs-input="update_input" 
                  v-model="editingSection.value.color"
                  @change="updateInputTextValue('colorInput', editingSection.value.color)" />
                >
              </div>
              <zt-input
                class="ml-4"
                label="Color de texto"
                v-model="editingSection.value.color"
                ref="colorInput"
                data-vs-input="edit_section" 
                outlined />
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div class="zt-modal-footer flex justify-between items-center p-4 bg-zt-dark-100">
          <div>
            <zt-button
              class="ml-1 w-11/12"
              color="disabled"
              style="color: #707070 !important"
              data-vs-button="restore" 
              @click="restoreSection()">
               {{ $t('message.customEmails.restore') }}
            </zt-button>
          </div>
          <div class="d-flex justify-end">
            <div>
              <zt-button
                @click="editModal = false"
                class="ml-1 button-cancel-only-text w-11/12"
                color="disabled"
                data-vs-button="cancel" 
                style="color: #707070 !important">
                 {{ $t('message.customEmails.cancel') }}
              </zt-button>
            </div>
            <div>
              <zt-button @click="TemplateSaveEdit()" data-vs-button="save" class="ml-1 w-11/12">
                {{ $t('message.customEmails.accept') }}
              </zt-button>
            </div>
          </div>
        </div>
      </template>
    </zt-modal>
    <Modal
      @closeDialog="modalConfirm.active = false"
      :modalConfirm="modalConfirm"
      @confirm="confirmModal" />
  </div>
</template>

<script>
  import Emails from '@/apiClient/Emails';
  import libraryModal from '../components/imageLibrary/libraryModal';
  import Modal from '../components/ModalConfirm.vue';
  export default {
    name: 'editEmail',
    components: {
      libraryModal,
      Modal,
    },
    data() {
      return {
        emails: '',
        sections: [],
        isLoading: false,
        editModal: false,
        editingSection: {},
        sectionReference: [],
        vars: [],
        imageLibraryModal: false,
        defaultSections: [],
        restoreDefault: false,
        preDefaultSections: [],
        validations:[],
        modalConfirm: {
          active: false,
          text: '',
          caption:'',
          confirmBtn: '',
          cancelBtn:'',
          type: ''
        },
        init:[]
      };
    },
    mounted() {
      this.emails = new Emails();
      this.emails.getTemplate(this.$route.params.idEmail).then(response => {
        const {sections, vars} = response.data.data;
        this.initSections = JSON.parse(JSON.stringify(sections))
        this.sections = sections;
        this.vars = vars;
      });
      this.emails.getDefaultTemplate(this.$route.params.idEmail).then(response => {
        this.defaultSections = response.data.data.sections;
      });
    },
    created(){
      this.redirectToListIfNoId()
    },
    methods: {
      hasHistory() {
        return window.history.length > 2;
      },
      goBack() {
        this.hasHistory() ? this.$router.go(-1) : this.$router.push('/');
      },
      buttonStyles(section) {
        return `border-radius: 8px; background-color: ${section.value.bgcolor}; color: ${section.value.color}; max-width: 250px;  display: inline-block; text-align: center; font-size:17px; font-weight: bold; padding: 12px 7% 12px 7%;text-decoration: none;`;
      },
      openModal(section) {
        this.editingSection = { ...section };
        if (section.type == 'btn') {
          this.editingSection.value = { ...section.value };
        }
        this.sectionReference = section;

        section.type === 'img' ? (this.imageLibraryModal = true) : (this.editModal = true);
      },
      TemplateSaveEdit() {
        if(!this.validations.length) {
        this.sectionReference.value = this.editingSection.value;
        this.editModal = false;}
      },
      updateInputTextValue(input, value) {
        this.$refs[input].textFieldValue = value;
      },
      saveTemplate() {
        const params = {
          json: { sections: this.sections, vars: this.vars },
          template: this.$route.params.idEmail,
        };
        this.emails.postTemplate(params).then(res => {
          (this.modalConfirm.active = false), this.goBack();
        });
      },
      addVariable(value) {
        const chipValue = `{${value}}`;
        const el = this.$refs.textarea;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const text = el.value;
        const before = text.substring(0, start);
        const after = text.substring(end, text.length);
        el.value = before + chipValue + after;
        this.editingSection.value = before + chipValue + after;
        el.selectionStart = el.selectionEnd = start + chipValue.length;
        el.focus();
      },
      restoreDefaultSections() {
        if (this.restoreDefault) {
          this.preDefaultSections = JSON.parse(JSON.stringify(this.sections));
          this.sections = JSON.parse(JSON.stringify(this.defaultSections));
        } else {
          this.sections = this.preDefaultSections;
        }
      },
      restoreSection() {
        const defaultSection = this.defaultSections.find(section => section.name == this.editingSection.name);
        this.editingSection = JSON.parse(JSON.stringify(defaultSection));
      },
      closeLibraryModal() {
        this.imageLibraryModal = false;
      },
      redirectToListIfNoId(){
        if(!this.$route.params.idEmail) {  this.$router.push('/CustomEmails/list')}
      },
      isValidHexaCode(str) {
           if (str[0] != '#')
               return false;
 
           if (!(str.length == 4 || str.length == 7))
               return false;
 
           for (let i = 1; i < str.length; i++)
               if (!((str[i].charCodeAt(0) <= '0'.charCodeAt(0) && str[i].charCodeAt(0) <= 9)
                   || (str[i].charCodeAt(0) >= 'a'.charCodeAt(0) && str[i].charCodeAt(0) <= 'f'.charCodeAt(0))
                   || (str[i].charCodeAt(0) >= 'A'.charCodeAt(0) || str[i].charCodeAt(0) <= 'F'.charCodeAt(0))))
                   return false;
 
           return true;
      },
      cancelarEditEmail(){
        if(JSON.stringify(this.initSections) === JSON.stringify(this.sections)) {
          this.goBack()
        } else {
          this.modalConfirm = {
            active: true,
            text: this.$t('message.customEmails.cancelModal.message'),
            caption: this.$t('message.customEmails.cancelModal.caption'),
            confirmBtn: this.$t('message.customEmails.cancelModal.confirmBtn'),
            cancelBtn: this.$t('message.customEmails.cancelModal.cancelBtn'),
          }
       }
      },
      confirmarEditEmail(){
        this.modalConfirm = {
          active: true,
          text: this.$t('message.customEmails.confirmModal.message'),
          confirmBtn: this.$t('message.customEmails.confirmModal.confirmBtn'),
          cancelBtn: this.$t('message.customEmails.confirmModal.cancelBtn'),
          type: "modal-confirm"
        }
      },
      confirmModal() {
        this.modalConfirm.type === "modal-confirm" ? this.saveTemplate() : this.goBack();
      },
      saveImage(imageUrl) {
        this.editingSection.value = imageUrl
        this.sectionReference.value = this.editingSection.value;
      }
    },
  watch: {
    editingSection: {
      handler() {
        if (this.editingSection.type == "btn") {
          const { bgcolor, color, text } = this.editingSection.value;
          [bgcolor, color, text].includes("")
            ? (this.validations = ["Este campo es requerido"])
            : (this.validations = []);

          [this.isValidHexaCode(bgcolor), this.isValidHexaCode(color)].includes(
            false
          )
            ? (this.validations = ["Solo se admite formato de color tipo HEX"])
            : "";
        }
      },
      deep: true,
      immediate: false,
    },
  },
    
  };
</script>

<style lang="scss" scoped>
  .main-container {
    width: 610px;
    h2 {
      font-size: 24px;
    }
    .heading {
      height: 50px;
      h2 {
        color: #707070;
      }
    }
    .main {
      height: auto;
    } 
    ::v-deep {
      .zt-button.go-back {
        background: none !important;
        color: #707070 !important;
        padding: 4px !important;
        margin: 0;
        font-size: 1.2rem !important;
        span:first-child {
          width: 10px;
        }
        span.zt-button-text {
          margin-top: 2px;
        }
      }
    }
   .section:hover {
    background-color: #dedede;
    .toggleDisplay {
      display: block !important;
      position: absolute;
      right: 10%;
    }
    .toggleDisplay.helpIcon {
      right: 93%;
      color: #575757;
    }
    .tooltiptext {
      visibility: hidden;
      border: solid 1px #bdbdbd;
      border-radius: 5px;
      background-color: #575757;
      position: absolute;
      font-size: 14px;
      font-weight: 400;
      color: white;
      padding: 10px 20px;
      width: 550px;
      z-index: 1000;
      box-shadow: 3px 3px 10px;
      bottom: 100%;
      transform: translateX(-50%);
    }
    .helpIcon:hover {
      .tooltiptext {
        visibility: visible;
      }
    }
  }
    
  }
  .container {
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 56px 75px;
    width: 800px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 5px 5px 0px 0px;
    h1 {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      color: #2d2d2d;
    }
    table,
    td {
      align-items: center;
    }
    table {
      border-spacing: 0;
      border-collapse: collapse;
      table-layout: fixed;
      margin: 0 auto;
    }
    img {
      -ms-interpolation-mode: bicubic;
      max-width: 100%;
      border: 0;
    }
    *[x-apple-data-detectors] {
      color: inherit !important;
      text-decoration: none !important;
    }
    .x-gmail-data-detectors,
    .x-gmail-data-detectors *,
    .aBn {
      border-bottom: 0 !important;
      cursor: default !important;
    }
    .btn {
      -webkit-transition: all 200ms ease;
      transition: all 200ms ease;
    }
    .btn:hover {
      background-color: dodgerblue;
    }
    .sichern-logo {
      max-width: 178px;
    }
  }
  .color-pick {
    width: 60px;
    height: 50px;
    overflow: hidden;
    border-radius: 100%;
  }
  input[type='color'] {
    width: 100%;
    height: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000001a;
    transform: scale(1.5);
  }
  textarea {
    border: 1px solid #898dff !important;
    border-radius: 4px;
    line-height: 28px;
    padding: 20px 12px;
  }
  .infoChip {
    color: #0298f1;
    background: #e1f5fe;
    border: 1px solid #0298f1;
    border-radius: 5px;
    font-weight: 700;
  }
  textarea:focus {
    outline: none !important;
    box-shadow: 0 0 5px #898dff;
  }
  .footer {
    text-align: right;
    width: 100%;
    background: #ebebeb;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 5px 5px;
    padding: 16px 75px;
    width: 800px;
  }
  @media all and (max-width: 1024px) {
    .main-container {
      width: calc(100% - 4rem);
    }
  }
</style>
